<template>
  <div class="fix-tool">
    <!-- 在线客服 -->
    <div class="position-box-wrapper">
      <a :href="aiLink" target="_blank">
        <div class="ai-box-wrapper">
          <div class="ai-wrapper">
            <img src="~@/assets/images/ai.gif" alt="" />
          </div>
          <div class="box-title">智能客服</div>
          <div class="ai-tip">有问题找我哦~</div>
        </div>
      </a>
    </div>

    <!-- 微信二维码 -->
    <div class="tool-item position-box-wrapper">
      <img
        class="active wechat"
        :src="`${ossUrl}/portal/static/icon/wechat.png`"
        alt=""
      />
      <img
        class="in-active wechat"
        :src="`${ossUrl}/portal/static/icon/wechat-active.png`"
        alt=""
      />
      <!--      微信公众号二维码-->
      <div class="position-box customer-service">
        <div class="qr-code">
          <div class="text">微信扫码咨询客服</div>
          <img
            :src="`${ossUrl}/portal/static/image/kefu_1.jpg`"
            style="width: 110px; height: 110px; vertical-align: top"
          />
        </div>
      </div>
    </div>

    <!-- 联系方式 -->
    <div class="tool-item position-box-wrapper">
      <img
        class="active vertical-middle-item"
        :src="`${ossUrl}/portal/static/icon/icon-phone-active.png`"
        alt=""
      />
      <img
        class="in-active vertical-middle-item"
        :src="`${ossUrl}/portal/static/icon/icon-phone.png`"
        alt=""
      />

      <div class="position-box contact-method">
        <p>
          <img
            :src="`${ossUrl}/portal/static/icon/icon-phone-small-theme.png`"
            alt=""
          />
          联系电话：{{ global.phone }}
        </p>
        <p class="m-t-20">
          <img
            :src="`${ossUrl}/portal/static/icon/icon-emil-theme.png`"
            alt=""
          />
          邮箱地址：{{ global.email }}
        </p>
        <p class="m-t-20">
          <img
            :src="`${ossUrl}/portal/static/icon/work-time-theme.png`"
            alt=""
          />
          工作时间（工作日）：{{ global.workTime }}
        </p>
      </div>
    </div>

    <div v-if="customerShow" class="position-box-wrapper">
      <div class="position-fix-box">
        <div class="content">
          <i
            class="iconfont icon--_x content-icon"
            @click="customerShow = false"
          ></i>
          <div>有什么可以帮助您吗？</div>
          <div class="m-t-5">点我立刻解答您的疑惑！</div>
        </div>
        <div class="btn-box">
          <div class="btn btn1">
            <i class="iconfont icon--_kefurexian m-r-5"></i>
            客服热线
            <div class="phone-box">
              <div class="phone-text">
                <div class="triangle"></div>
                客服热线：{{ global.phone }}
              </div>
            </div>
          </div>
          <a class="btn btn2" :href="aiLink">
            <i class="iconfont icon--_zaixianzixun m-r-5"></i>
            在线咨询
            <!-- <div class="qr-code-box">
              <div class="qr-code-content">
                <div class="triangle"></div>
                <div>
                  <div class="m-b-12">微信扫码咨询客服</div>
                  <img
                    :src="`${ossUrl}/portal/static/image/kefu_1.jpg`"
                    style="width: 110px; height: 110px; vertical-align: top"
                  />
                </div>
              </div>
            </div> -->
          </a>
        </div>
      </div>
    </div>

    <!-- 标前狗平台banner -->
    <div
      class="banner-tool-item position-box-wrapper vertical-middle"
      @click="toValueAdded"
    >
      <img
        :src="`${ossUrl}/portal/static/image/value-added-fix-tool.png`"
        width="50px"
        height="100%"
      />
    </div>

    <!-- 返回顶部 -->
    <el-backtop style="right: 0; bottom: 0">
      <div class="tool-item vertical-middle">
        <img
          class="active vertical-middle-item"
          :src="`${ossUrl}/portal/static/icon/icon-up.png`"
          alt=""
        />
        <img
          class="in-active vertical-middle-item"
          :src="`${ossUrl}/portal/static/icon/icon-up-active.png`"
          alt=""
        />
      </div>
    </el-backtop>
  </div>
</template>

<script>
import { globalVar } from '@/utils/common'
import { mapState } from 'vuex'

export default {
  name: 'FixTool',

  data() {
    return {
      global: globalVar(),
      customerShow: true
    }
  },

  computed: {
    ossUrl() {
      return process.env.VUE_APP_OSS_URL
    },

    aiLink() {
      return `${process.env.VUE_APP_PORTAL_URL}/ai-service`
    }
  },

  methods: {
    toValueAdded() {
      // 如果当前是首页，则刷新页面
      if (this.$route.name === 'Home') {
        location.reload()
        return
      }
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fix-tool {
  position: fixed;
  top: calc(50% - 150px);
  right: 20px;
  z-index: 1000;

  .tool-item {
    display: block;
    width: 50px;
    margin: 0 auto;
    min-height: 50px;
    border-radius: 6px;
    text-align: center;
    background: $white-color;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 2px $info-third-color;

    & + .tool-item {
      margin-top: 10px;
    }

    & > img {
      height: 24px;
      width: auto;
      vertical-align: middle;
    }
    .icon {
      font-size: 28px;
    }
    .in-active {
      display: inline-block;
    }
    .active {
      display: none;
    }

    &:hover {
      background: $primary-color;
      color: $white-color;

      .in-active {
        display: none;
      }
      .active {
        display: inline-block;
      }
    }
  }

  .ai-box-wrapper {
    position: relative;
    cursor: pointer;
    width: 64px;
    height: 64px;
    margin-bottom: 10px;

    .ai-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        position: absolute;
        top: 0;
      }
    }

    .box-title {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 12px;
      padding: 2px 8px;
      color: $white-color;
      background-color: $primary-color;
      border-radius: 10px;
    }

    .ai-tip {
      position: absolute;
      top: 0;
      right: 100%;
      padding: 4px 6px;
      border-radius: 4px;
      color: $primary-color;
      background-color: #d8ebff;
      white-space: nowrap;
      transform-origin: top right;
      animation: fadeOut 2s infinite alternate ease-in-out;
    }
  }

  .banner-tool-item {
    width: 50px;
    margin: 10px auto 0;
    cursor: pointer;
  }

  // 重新第一el-backtop
  ::v-deep .el-backtop {
    margin-top: 40px;
    position: relative;
    width: auto;
    height: auto;
    box-shadow: none;
    color: $text-color;
    background: transparent;
  }

  // 浮动展示的内容
  .position-box-wrapper {
    position: relative;
    .kefu-icon {
      font-size: 30px;
      color: $primary-color;
    }
    .position-box {
      position: absolute;
      top: 0;
      right: calc(100% + 10px);
      border-radius: 6px;
      color: $text-color;
      background: $white-color;
      transform: scale(0);
      transform-origin: right top;
      transition: transform 0.3s ease-in-out;
      box-shadow: 0 0 2px $info-third-color;
    }

    &:hover {
      .position-box {
        transform: scale(1);
      }
      .kefu-icon {
        color: $white-color;
      }
    }
    .qr-code {
      box-sizing: border-box;
      padding: 12px;
      width: 150px;
      .text {
        font-size: 14px;
        color: $text-color;
        margin-bottom: 12px;
      }
    }
    .position-fix-box {
      position: absolute;
      top: 100px;
      right: calc(100% + 10px);
      border-radius: 6px;
      width: 250px;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.14);
      background: #fff;
      .content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border-bottom: 1px solid #eaeaea;
        padding: 20px 44px;
        position: relative;
        .content-icon {
          position: absolute;
          right: 8px;
          top: 8px;
          cursor: pointer;
        }
      }
      .btn-box {
        display: flex;
        height: 35px;
        .btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          font-size: 14px;
          color: $primary-color;
          cursor: pointer;
          position: relative;
        }
        .btn1 {
          border-right: 1px solid #eaeaea;
          .phone-box {
            opacity: 0;
            position: absolute;
            bottom: -70px;
            left: 0px;
            .phone-text {
              width: 200px;
              height: 50px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: $text-color;
              box-sizing: border-box;
              background: $white-color;
              position: relative;
              border-radius: 4px;
              box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
              .triangle {
                position: absolute;
                top: -8px;
                left: 55px;
                width: 0;
                height: 0;
                border-bottom: 8px solid $white-color;
                border-right: 8px solid transparent;
                border-left: 8px solid transparent;
              }
            }
          }
          &:hover {
            .phone-box {
              opacity: 1;
            }
          }
        }
        .btn2 {
          border-right: 1px solid #eaeaea;
          .qr-code-box {
            opacity: 0;
            position: absolute;
            bottom: -180px;
            left: 0px;
            .qr-code-content {
              width: 140px;
              height: 160px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: $text-color;
              box-sizing: border-box;
              background: $white-color;
              position: relative;
              border-radius: 4px;
              box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
              .triangle {
                position: absolute;
                top: -8px;
                left: 55px;
                width: 0;
                height: 0;
                border-bottom: 8px solid $white-color;
                border-right: 8px solid transparent;
                border-left: 8px solid transparent;
              }
            }
          }
          &:hover {
            .qr-code-box {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  // 标前狗宣传
  .biddog-publicity-text {
    writing-mode: vertical-lr;
    padding: 16px 20px;
  }

  // 联系方式
  .contact-method {
    padding: 20px;
    text-align: left;
    width: 250px;

    img {
      vertical-align: -1px;
      margin-right: 4px;
    }
  }
}
</style>
